import Face3OutlinedIcon from '@mui/icons-material/Face3Outlined';

/**
 * Escala de Ludwig: rarefação feminina de padrão (alopecia androgenética na
 * mulher), em três graus. Referência clínica: Ludwig E (Br J Dermatol,
 * 1977;97:247-54). A escala de Savin, mais detalhada, é um módulo à parte
 * (savin.js). Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/ludwig.php.
 */
const ludwig = {
  key: 'ludwig',
  name: 'Escala de Ludwig',
  description: 'Rarefação feminina de padrão, do grau I ao III',
  details: 'Classifica a rarefação do cabelo feminino no topo da cabeça em três graus, olhando a risca central: do grau I (risca um pouco mais larga) ao III (couro cabeludo bem visível no topo). A linha frontal costuma ficar preservada. Ajuda a indicar o tratamento e a acompanhar a resposta com o tempo. Um clique marca o grau do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: Face3OutlinedIcon,
  accent: 'purple',
  options: [
    { value: 'I', label: 'Grau I', caption: 'Leve', image: 'ludwig-1.png', help: 'Risca central um pouco mais larga, com rarefação discreta no topo. Frente preservada.' },
    { value: 'II', label: 'Grau II', caption: 'Moderado', image: 'ludwig-2.png', help: 'Rarefação evidente no topo, com o couro cabeludo aparecendo ao redor da risca.' },
    { value: 'III', label: 'Grau III', caption: 'Intenso', image: 'ludwig-3.png', help: 'Topo da cabeça quase sem cobertura, com a faixa frontal ainda presente.' },
  ],
};

export default ludwig;
